import React from 'react';

const Frame = ({url}) => (
    <iframe src={url} height="500" style={{width: '100%'}} scrolling="no" title="Codepen"  frameBorder="no" loading="lazy" allowtransparency="true" allowFullScreen={true} className='blog__codepen' />
);

export default Frame;